import { render } from "./WhatsappOnboardingWizard.vue?vue&type=template&id=6c95442e"
import script from "./WhatsappOnboardingWizard.vue?vue&type=script&lang=ts"
export * from "./WhatsappOnboardingWizard.vue?vue&type=script&lang=ts"

import "./WhatsappOnboardingWizard.vue?vue&type=style&index=0&id=6c95442e&lang=scss"
script.render = render

export default script